export default function LandingPage() {
  return (
    <iframe
      title="Atas Digitais Stant"
      src="/lp/index.html"
      className="fixed inset-0 h-screen w-screen border-0"
    />
  );
}
